import { FC, PropsWithChildren } from "react";
import classNames from "classnames";
import { Bold } from "capitalrx-components-2.0/lib/typography";
import styles from "./styles.module.scss";

/**
 * A group heading component.
 */
export const GroupHeading: FC<PropsWithChildren<{}>> = (props) => {
  const { children } = props;

  return (
    <div className={classNames(styles.GroupHeading, "group-heading")}>
      <Bold>{children}</Bold>
    </div>
  );
};
